import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import AddServiceItems from "../BasketItems/ModalAddServiceItems/AddServiceItems";
import EditOrderPerson from "./ModalEditOrderPerson/EditOrderPerson";
import ViewHistoryOrderPerson from "./ModalViewHistoryOrderPerson/ViewHistoryOrderPerson";
import CopyToClipboard from "../../../_Components/CopyToClipboard";

function UserOrderPersonIndex(props) {
  const [showModalHistoryOrder, setShowModalHistoryOrder] = useState(false);
  const [showModalAddserviceItem, setShowModalAddserviceItem] = useState(false);
  const [showModalEditOrder, setShowModalEditOrder] = useState(false);

  const service = props.service;

  const handleShowHistoryOrder = () => {
    setShowModalHistoryOrder(!showModalHistoryOrder);
  };

  const handleshowEditOrder = () => {
    setShowModalEditOrder(!showModalEditOrder);
    props.callBack();
  };

  const handleShowModalAddserviceItem = () => {
    setShowModalAddserviceItem(!showModalAddserviceItem);
    props.callBack();
  };

  let showPrice = Intl.NumberFormat("en-US");

  return (
    <>
      {/* --------------------------مودال های مورد استفاده در این بخش--------------------------------------------------------------------------------------- */}
      {showModalHistoryOrder && <ViewHistoryOrderPerson callBack={handleShowHistoryOrder} basketId={props.basketId} />}
      {showModalEditOrder && (
        <EditOrderPerson callBack={handleshowEditOrder} basketId={props.basketId} person={service?.userOrderSelected} />
      )}
      {showModalAddserviceItem && (
        <AddServiceItems
          callBack={handleShowModalAddserviceItem}
          basketId={props.basketId}
          basketItemPerson={props.service.basketPersons}
        />
      )}

      {/* --------------------------نمایش اطلاعات فرد سفارش دهنده -------------------------------------------------------------------------------------------- */}
      <Card className="bg-wihte w-100 mt-0 mb-4 p-3 rounded-xl  border border-secondary">
        <Row className="align-items-center border-bottom">
          <Col xs="6" sm>
            <div className="mb-3">
              <CopyToClipboard
                showIcon={true}
                copyDate={service?.userOrderSelected?.firstName + " " + service?.userOrderSelected?.lastName}
                htmlText={
                  `<div className="m-0 p-0">
              <h3 className="mx-3 pl-2 mt-3 mb-0 text-hover-primary cursor-pointer fs-large" data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"
                >` +
                  service?.userOrderSelected?.firstName +
                  " " +
                  service?.userOrderSelected?.lastName +
                  `</h3>
            </div>`
                }
              ></CopyToClipboard>
            </div>
          </Col>
          <Col xs="6" sm="auto">
            <div className="btn-group-sm d-flex justify-content-end mb-3">
              <button type="button" className="btn  btn-light-secondary mx-1 " onClick={handleShowHistoryOrder}>
                <p className="fas fa-history text-dark fa-sm my-0"></p>
              </button>
              <button type="button" className="btn btn-light-primary mx-1" onClick={handleshowEditOrder}>
                <p className="far fa-edit  fa-sm my-0"></p>
              </button>
              {/* <button
                type="button"
                className="btn  btn-light-success mx-1  "
                onClick={handleShowModalAddserviceItem}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="tooltip-dark"
                title="اضافه کردن تفریحات به سبد"
                data-bs-delay-hide="1000"
              >
                <p className="fa fa-plus fa-md my-0"></p>
              </button> */}
            </div>
          </Col>
        </Row>
        <Row className="pt-5">
          <Col xs="auto">
            <CopyToClipboard
              showIcon={true}
              copyDate={service?.userOrderSelected?.phoneNumber}
              htmlText={
                `<span class="mx-3 cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span class="text-hover-primary">  ` +
                service?.userOrderSelected?.phoneNumber +
                ` <i class="mr-2 fas fa-phone fa-sm text-hover-primary flipX"></i></span>    </span>`
              }
            ></CopyToClipboard>
            {/* <p
              className=" text-muted cursor-pointer"
              data-toggle="tooltip"
              data-placement="top"
              title="برای کپی کلیک کنید"
              onClick={() => {
                copyToClipboard(service?.userOrderSelected?.phoneNumber);
              }}
            >
              <span className="text-hover-primary text-muted">
                <small className="mx-2 fas fa-phone fa-sm text-hover-primary"></small>
                {service?.userOrderSelected?.phoneNumber}
              </span>
            </p> */}
          </Col>
          <Col xs="auto" className="">
            <p className=" text-muted ">
              <small className="fas fa-shopping-basket"></small>
              <span className="mx-2 ">مجموع سبد خرید : {showPrice.format(service?.basket?.price)} تومان</span>
            </p>
          </Col>
          <Col xs="auto" className="">
            <p className=" text-muted ">
              <small className="fas fa-gift"></small>
              <span className="mx-2 ">کد تخفیف:{service?.basket?.promoCode ? service.basket.promoCode : " --- "}</span>
            </p>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default UserOrderPersonIndex;
